const COMMUNICATIONS_BASE_URL = 'https://tophamtechbe.com/api/treas/comm';

export class DripHistoryRequestError extends Error {
  constructor(message, status, code) {
    super(message);
    this.name = 'DripHistoryRequestError';
    this.status = status;
    this.code = code || '';
  }
}

export const getCustomerDripHistory = async ({ user, siteId, emailAddress, signal } = {}) => {
  const normalizedSiteId = String(siteId || '').trim();
  const normalizedEmail = String(emailAddress || '').trim();

  if (!user?.token) {
    throw new DripHistoryRequestError(
      'Your session is missing an authentication token. Please sign in again.',
      401,
      'UNAUTHORIZED'
    );
  }
  if (!normalizedSiteId) throw new Error('The authenticated site is unavailable.');
  if (!normalizedEmail || !normalizedEmail.includes('@')) {
    throw new Error('A valid customer email address is required.');
  }

  const params = new URLSearchParams({
    siteId: normalizedSiteId,
    emailAddress: normalizedEmail
  });
  const response = await fetch(
    COMMUNICATIONS_BASE_URL + '/drip-enrollments/history?' + params,
    {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: (user.type || 'Bearer') + ' ' + user.token
      },
      signal
    }
  );

  if (!response.ok) {
    const payload = await response.json().catch(() => ({}));
    const fallback = response.status === 401
      ? 'Your session has expired. Please sign in again.'
      : response.status === 403
        ? 'You are not authorized to view this customer’s email history.'
        : response.status === 503
          ? 'Email history is temporarily unavailable while authentication is being verified.'
          : 'Customer email history is temporarily unavailable.';
    throw new DripHistoryRequestError(payload.message || fallback, response.status, payload.code);
  }

  return response.json();
};
